import { http } from '../axios';
import { shopPrefix } from '../../config';
import { AnalyseResponseOut } from '../../store/api';

const url = `${shopPrefix}/v1/analyse/list/:listId`;

export const fetchSelectionListAnalyse = (listId: string) => {
    return http
        .get<AnalyseResponseOut>(url, {
            pathParams: { listId }
        })
        .then(response => response.data);
};
